import type { ComponentPropsWithoutRef } from 'react';

import { Link } from '#components/Link/Link';
import { buildBoardPath } from '#cutils/builders/buildBoardPath';

import styles from './ArticleSectionTags.module.scss';
import type { ArticleSectionTagsFragment } from './__generated__/ArticleSectionTags.generated';

type Props = {
	tags: ArticleSectionTagsFragment[];
} & ComponentPropsWithoutRef<'ul'>;

export function ArticleSectionTags({ tags, className = '', ...props }: Props) {
	return (
		<ul className={`${styles.tags} ${className} heading4`} {...props}>
			{tags.map((tag) => {
				const linkedBoard = tag.boardsByTagId.nodes[0];

				const isBoard = !!linkedBoard?.path;

				return (
					<li className={styles.listItem} key={tag.rowId}>
						<Link
							className={`${styles.tagLink} no-hover no-focus no-active`}
							href={
								isBoard
									? buildBoardPath(linkedBoard.rowId, linkedBoard.slug, linkedBoard.path)
									: `/suche?param=${encodeURIComponent(tag.text)}`
							}
						>
							{tag.text}
						</Link>
					</li>
				);
			})}
		</ul>
	);
}
